import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { locales } from 'config'
import Col from 'components/Col/Col'
import Link from 'components/Link/Link'
import {
  Wrapper,
  Container,
  StyledLink,
  StyledParagraph,
  CloseIcon,
} from './CookiesBannerStyle'

const CookiesBanner = ({
  cookiesBannerIsOpen,
  context,
  showCookiesBanner,
  locale,
}) => {
  const handleClose = () => {
    showCookiesBanner(false)
  }

  return (
    <Wrapper id="cookies-banner">
      {cookiesBannerIsOpen && (
        <Container>
          <Col xs={10} m={11}>
            <StyledParagraph>
              <FormattedMessage id={`cookies.${context}.message`} />{' '}
              <StyledLink
                to={locales[locale].cookiesUrl[context]}
                target="_blank"
              >
                <FormattedMessage id={`cookies.${context}.more`} />
              </StyledLink>
            </StyledParagraph>
          </Col>
          <Col xs={2} m={1}>
            <Link onClick={handleClose} className="close-icon">
              <CloseIcon icon="close" />
            </Link>
          </Col>
        </Container>
      )}
    </Wrapper>
  )
}

CookiesBanner.propTypes = {
  cookiesBannerIsOpen: PropTypes.bool,
  context: PropTypes.string.isRequired,
  showCookiesBanner: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
}

export default CookiesBanner
